import { APP_ROUTES } from '@lib/route/constants';
import { Tenant } from '@lib/tenants/types';

export const TELFI_CONFIG: Tenant = {
  config: {
    setup: {
      id: {
        local: undefined,
        demo: undefined,
        qa: undefined,
        prod: 'TELFI',
        staging: 'TELFI',
      },
      name: 'telfi',
      cmsSubdomain: {
        local: undefined,
        demo: undefined,
        staging: 'telfi-staging',
        qa: undefined,
        prod: 'telfi-production',
      },
      ryftPublicKey: {
        local: undefined,
        demo: undefined,
        qa: undefined,
        prod: undefined,
        staging:
          'pk_sandbox_wCLdq9JLAk1H+gqjotrJ4Thr6VaUI3+2CTpruusTyVnFeE54vPMiF9B+hYVa0kyy',
      },
      paypalPublicKey: {
        local: undefined,
        demo: undefined,
        qa: undefined,
        prod: 'ASShB9th1Lll7hGTJYq4L34kVQ52iPZ9oSYjugvthvUNKHYa0jieREOiUT0fnMlc-1BTfu_QljMZyfnH',
        staging:
          'ASShB9th1Lll7hGTJYq4L34kVQ52iPZ9oSYjugvthvUNKHYa0jieREOiUT0fnMlc-1BTfu_QljMZyfnH',
      },
      authTenantId: {
        local: undefined,
        demo: undefined,
        staging: 'vbq7qm5b',
        qa: undefined,
        prod: '6nzzgy4n',
      },
      ocbDigitalBaseUrl: {
        demo: undefined,
        qa: undefined,
        prod: 'https://telfi.world/digital/api',
        staging: 'https://staging.telfi.world/digital/api',
      },
    },
  },
  cmsRoutes: [
    {
      type: 'page',
      path: APP_ROUTES.ROOT_UID.path,
    },
    {
      type: 'home-page',
      path: APP_ROUTES.HOME.path,
    },
    {
      type: 'privacy-policy',
      path: APP_ROUTES.PRIVACY_POLICY.path,
    },
    {
      type: 'available_products',
      path: APP_ROUTES.PLANS.path,
    },
    {
      type: 'terms-and-conditions',
      path: APP_ROUTES.TERMS_AND_CONDITIONS.path,
    },
  ],
  theme: {},
  seo: {
    displayName: 'TelFi',
  },
};
